import { prefetchIndexLists } from '@/lib/detail/list-prefetch';
import { DEFAULT_LOCALE, isSupportedLocale, type Locale } from '@todo/core/i18n/locales';
import { LIST_BUCKET, WINE_TOUR_CITIES_SEED_KEY } from '@todo/core/list-queries';
import { getPrefetched } from '@todo/core/static-prefetch';

// Shared by app/[lang]/wine-tours/[city]. Only cities with enough wine tours
// (MIN_WINE_TOURS_PER_PAGE) are exported — read from the same prefetched list
// the hub bakes for its "by departure city" links, so the hub can never link
// to a city page that wasn't exported. Same `{lang, city}[]` shape and
// explicit-`lang` reasoning as generateCityStaticParams (city-detail.ts).
export async function generateWineCityStaticParams({
  params,
}: {
  params: { lang?: string };
}): Promise<{ lang: string; city: string }[]> {
  // Already awaited by app/[lang]/_layout.tsx; memoized, so this is free and
  // just makes the dependency explicit.
  await prefetchIndexLists();
  const locale: Locale = isSupportedLocale(params.lang) ? params.lang : DEFAULT_LOCALE;
  const cityIds = getPrefetched<string[]>(LIST_BUCKET, WINE_TOUR_CITIES_SEED_KEY) ?? [];
  return cityIds.map((city) => ({ lang: locale, city }));
}
